export default __webpack_public_path__ + "assets/bronstein-component.3831a855.svg";